import React from 'react'
import classNames from 'classnames'
import { ReactSVG } from 'react-svg'
import PaginationControl from './PaginationControl'
import { clone, uniq } from 'lodash-es'

interface Props {
  total: number
  className?: string
  queryMode?: boolean
  queryKey?: string
  current?: number
  onChange?: (current: number) => any
  limit?: number
}

const Pagination: React.FC<Props> = ({
  total,
  className = '',
  // queryMode = true,
  // queryKey = 'page',
  current = 1,
  onChange,
  limit = 3
}) => {
  const [value, setValue] = React.useState(current)

  React.useEffect(() => {
    setValue(current)
  }, [current])

  const visibleIndexes = React.useMemo<Array<number>>(() => {
    let i = limit
    let res: any[] = [value]

    while (i > 0) {
      res.push(value + i)
      res.push(value - i)

      i--
    }

    res = res.filter((i) => i > 0 && i <= total)

    res = uniq(res).sort((a, b) => a - b)
    const _res = clone(res)

    res.forEach((n) => {
      if (n < 1) {
        const val = _res[_res.length - 1] + 1

        if (val <= total) {
          _res.push(val)
          _res.splice(_res.indexOf(n), 1)
        }
      }

      if (n > total) {
        const val = _res[0] - 1

        if (val >= 1) {
          _res.unshift(val)
          _res.splice(_res.indexOf(n), 1)
        }
      }
    })

    return _res
  }, [value, total])

  const handleChange = (val: number) => {
    setValue(val)
    onChange?.(val)
  }

  return (
    <div className={classNames('pagination', className)}>
      <PaginationControl
        onChange={handleChange}
        total={total}
        value={value}
        index={value - 1}
        prev
      >
        <ReactSVG
          src={'/i/svg/chevron-left.svg'}
          className={'svg-icon'}
          wrapper={'span'}
        ></ReactSVG>
      </PaginationControl>
      <div className="pagination__items">
        {visibleIndexes.map((index, indx) => (
          <PaginationControl
            onChange={handleChange}
            total={total}
            value={value}
            key={index}
            index={index}
            className={classNames({ _active: index === value })}
          >
            <span>
              {(index > 1 && !indx) ||
              (index < total && indx === visibleIndexes.length - 1)
                ? '...'
                : index}
            </span>
          </PaginationControl>
        ))}
      </div>
      <PaginationControl
        onChange={handleChange}
        total={total}
        value={value}
        index={value + 1}
        next
      >
        <ReactSVG
          src={'/i/svg/chevron-right.svg'}
          className={'svg-icon'}
          wrapper={'span'}
        ></ReactSVG>
      </PaginationControl>
    </div>
  )
}

export default Pagination
